<template>
  <a-modal title="添加客户原料"
    :visible="hidden"
    @ok="ok" 
    :bodyStyle="{padding:'10px'}"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="cancel"
    :footer="null"
    width="900px">
      <a-row style="padding:0 0 10px" type="flex" align="middle" justify="space-between">
        <a-col>
          <a-input-search size="small" v-model="filterData.name" @change="e => inputChange(e,'name')" placeholder="原料名称/代码" style="width: 180px;margin-right: 10px;" allowClear @search="e => onSearch(e,'name')" />
          <a-input-search v-if="overseasFlag==1" size="small" v-model="filterData.aliasName" @change="e => inputChange(e,'aliasName')" placeholder="原料别名" style="width: 180px" @search="e => onSearch(e,'aliasName')" />
        </a-col>
        <base-list-select style="width:300px" :value="rawType" @change="typeChange" placeholder="选择原料类型" category="raw" />
      </a-row>
      <a-table
        :columns="columns"
        bordered
        :scroll="{ x:0, y: 450 }"
        :row-selection="{selectedRowKeys, onSelect, onSelectAll}"
        :loading="nutLoading"
        :data-source="list.records"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="listChange"
      >
        <template slot="name" slot-scope="text,record">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
      </a-table>
      <a-row type="flex" justify="space-between" class="footer">
        <span>
          <span style="font-size:12px;">
          已选中 <span style="color: red;">{{selectedRows.length}}</span> 条原料
          </span>
        </span>
        <a-space>
          <a-button @click="cancel">取消</a-button>
          <a-button @click="ok" type="primary">保存</a-button>
        </a-space>
      </a-row>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'
export default {
  components: { BaseListSelect },
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return{
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading:false,
      filterData:{},
      list:{},
      showFooter:false,
      rawType:[],
      columns:[
        { 
          dataIndex:'name',
          title: '原料名称',
          width:300,
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          align:'center',
          title: '代码',
          width:110,
          scopedSlots: {customRender: 'code'},
        },
        {
          dataIndex:'rawTypeName',
          title: '类型',
        },
        {
          dataIndex:'unit',
          title: '单位',
          align:'center',
        },
      ]
    }
  },
  mounted(){
    // this.getList(this.pagination)
  },
  watch:{
    hidden(val){
      val ? this.getList({current: 1,size: 20}) :  this.restList()
    }
  },
  methods:{
    inputChange({ target }, feild) {
      this.pagination.current = 1;
      let {current=1,pageSize=20} = this.pagination || {}
      this.getList({[feild]:target.value,current,size: pageSize})
    },

    ok(){
      if(this.selectedRows.length){
        this.$emit('ok',this.selectedRows)
        this.cleanSelect()
      }else{
        this.$message.warn('选择需要添加的原料')
      }
    },
    
    cancel(){
      this.$emit('cancel')
    },

    getList(arg ={}){
      let {current=1,size=20} = arg || {}
      let data = {
        ...this.filterData,
        factoryId:this.factoryId,
        formulaId:this.formulaId,
        customId: this.detail.customId,
        query: {
          current,size
        }
      }
      return this.fetchPost({
        actions:this.getAddCustomFormulaRawList,
        isList:true,
        name:'list',
        showMessage: false,
        loading:'nutLoading',
        data
      })
    },

    onSearch(name, feild) {
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: name, current, size: pageSize });
    },

    typeChange(val){
      this.rawType = val
      const typeId = [...val].pop()
      this.filterData.typeId = typeId
      let {current=1,pageSize=100} = this.pagination || {}
      this.getList({typeId,current,size: pageSize})
    },
    restList(){
      this.rawType = []
      this.filterData ={}
      this.cleanSelect()
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>
<style lang="scss" scoped>
  .footer{
    padding:10px 15px 0;
    margin:10px -10px 0;
    border-top:1px solid #eee;
  }
</style>
